import {
  Grid,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  FormHelperText,
} from '@mui/material';
import { Box } from '@mui/system';
import { Passenger } from '~/types';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { BOOKING_CONTEXT } from '~/literals';
import CountrySelector from './CountrySelector';

interface PassengerDetailsFieldsProps {
  handleFieldChange: (fieldName: string, value: string) => void;
  passenger: Passenger;
  passengerErrors: Record<any, string[]>;
  documentErrors: Record<any, string[]>;
  bookingContext: string;
}

const PassengerDetailsFields = ({ handleFieldChange, passenger, passengerErrors, documentErrors, bookingContext }: PassengerDetailsFieldsProps) => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl component="fieldset">
            {
              bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY
              &&
              <>
                <FormLabel component="legend">Gender</FormLabel>

                <RadioGroup
                  row
                  aria-label="gender"
                  name={`gender-${passenger.id}`}
                  value={passenger.gender}
                  onChange={(event) => handleFieldChange(`gender-${passenger.id}`, event.target.value)}
                >
                  <FormControlLabel
                    value="MALE"
                    control={<Radio />}
                    label="Male"
                  />
                  <FormControlLabel
                    value="FEMALE"
                    control={<Radio />}
                    label="Female" />
                </RadioGroup>
              </>
            }
            {
              passengerErrors && passengerErrors?.gender?.length > 0 &&
              <FormHelperText error={true}>
                {passengerErrors && passengerErrors?.gender?.length > 0
                  ? passengerErrors?.gender?.join('\n')
                  : null}
              </FormHelperText>
            }
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY ? 4 : 6}>
          <TextField
            fullWidth
            label="First Name"
            variant="outlined"
            name={`firstName-${passenger.id}`}
            required
            autoComplete="new-password"
            onChange={(event) => handleFieldChange(`firstName-${passenger.id}`, event.target.value)}
            value={passenger.firstName}
            error={passengerErrors && passengerErrors?.firstName?.length > 0}
            helperText={
              passengerErrors && passengerErrors?.firstName?.length > 0
                ? passengerErrors?.firstName?.join('\n')
                : null
            }
          />
        </Grid>

        <Grid item xs={12} sm={bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY ? 4 : 6}>
          <TextField
            fullWidth
            label="Surname"
            autoComplete="new-password"
            variant="outlined"
            name={`lastName-${passenger.id}`}
            required
            value={passenger.lastName}
            onChange={(event) => handleFieldChange(`lastName-${passenger.id}`, event.target.value)}
            error={passengerErrors && passengerErrors?.lastName?.length > 0}
            helperText={
              passengerErrors && passengerErrors?.lastName?.length > 0
                ? passengerErrors?.lastName?.join('\n')
                : null
            }
          />
        </Grid>
        {
          bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY
          &&

          <Grid item xs={12} sm={4}>
            <DatePicker
              sx={{ width: '100%' }}
              label="Date of Birth*"
              name={`dateOfBirth-${passenger.id}`}
              value={passenger.dateOfBirth ? dayjs(passenger.dateOfBirth) : null}
              onChange={(value) => handleFieldChange(`dateOfBirth-${passenger.id}`, value?.format('YYYY-MM-DDTHH:mm:ss.SSSZ') || '')}
              maxDate={dayjs(new Date())}
              slotProps={{ textField: { autoComplete: 'new-password' } }}
            />
            {
              passengerErrors && passengerErrors?.dateOfBirth?.length > 0 &&
              <FormHelperText error={true}>
                {
                  passengerErrors && passengerErrors?.dateOfBirth?.length > 0
                    ? passengerErrors?.dateOfBirth?.join('\n')
                    : null
                }
              </FormHelperText>
            }
          </Grid>
        }
        {
          bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY && passenger?.documentsRequired && passenger?.documents
          &&
          <>
            <Grid item xs={12} sm={4}>
              <CountrySelector
                showFlags
                showCountryLabel
                handleFieldChange={(value) => handleFieldChange(`nationality-${passenger.id}`, value)}
                label='Nationality*'
                country={passenger?.documents[0].nationality.friendlyName}
                valueField='code'
                selectedDisplayField='label'
                errors={documentErrors?.nationality}
              />
            </Grid>

            <input
              type="hidden"
              required
              value={passenger?.documents[0].documentType}
              onChange={(event) => handleFieldChange(`documentType-${passenger.id}`, event.target.value)}
              name={`documentType-${passenger.id}`}
            />

            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Passport Number"
                variant="outlined"
                autoComplete="new-password"
                required
                onChange={(event) => handleFieldChange(`number-${passenger.id}`, event.target.value)}
                value={passenger?.documents[0].number}
                name={`number-${passenger.id}`}
                error={documentErrors && documentErrors?.number?.length > 0}
                helperText={
                  documentErrors && documentErrors?.number?.length > 0
                    ? documentErrors?.number?.join('\n')
                    : null
                }
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <DatePicker
                sx={{ width: '100%' }}
                label="Passport Expiry*"
                value={passenger?.documents[0].expiryDate ? dayjs(passenger?.documents[0].expiryDate) : null}
                onChange={(value) => handleFieldChange(`expiryDate-${passenger.id}`, value?.format('YYYY-MM-DDTHH:mm:ss.SSSZ') || '')}
                name={`expiryDate-${passenger.id}`}
                minDate={dayjs(new Date())}
                slotProps={{ textField: { autoComplete: 'new-password' } }}
              />
              {
                documentErrors && documentErrors?.expiryDate?.length > 0 &&
                <FormHelperText error={true}>
                  {
                    documentErrors && documentErrors?.expiryDate?.length > 0
                      ? documentErrors?.expiryDate?.join('\n')
                      : null
                  }
                </FormHelperText>
              }
            </Grid>
          </>
        }
      </Grid>
    </Box>
  );
};

export default PassengerDetailsFields;
